import type { DataTransferObject, TransactionId } from '../../../@types/DataTransferObject.js';
import type { Wager } from '../../../wager.js';
import type { MarketplaceWagerResponse, WagerResponse } from './types.js';

/**
 * Used to differentiate different payable items.
 *
 * @param wager The wager that was processed
 * @param wagerResponse The response from the payment request
 * @returns The payment data transfer object
 */
export function createPaymentDTO(
  wager: Wager,
  wagerResponse: WagerResponse | MarketplaceWagerResponse
): DataTransferObject {
  const isMarketplaceWager = wager.getIsMarketplaceWager();
  let accountBalance: number;

  if (!isMarketplaceWager && 'accountBalance' in wagerResponse) {
    accountBalance = wagerResponse.accountBalance;
  }

  return {
    get cost() {
      return Number.parseFloat(wagerResponse.wagerAmounts.totalAmount.replaceAll(',', '.'));
    },
    get balance() {
      return accountBalance;
    },
    get transactionId() {
      return wagerResponse.wagerClientSerial as TransactionId;
    },
    get couponIndex() {
      return wager.couponIndex;
    },
  } as const;
}
